// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XIvZ","label":"styles_label__vuneb"};